export const UPDATE_PACKAGE = "UPDATE_PACKAGE";
export const SET_NEWPACKAGE = "SET_NEWPACKAGE";
export const SAVE_PACKAGE = "SAVE_PACKAGE";
export const ADD_PACKAGE = "ADD_PACKAGE";
export const RESET_PACKAGE = "RESET_PACKAGE";
